// Complete Case Studies Data for All Projects
export const caseStudies = [
  {
    title: "Homework Rabbit: Fastest AI Homework Helper for All Subjects",
    category: "Education / AI Study Tool",
    challenge:
      "Students frequently face difficult homework problems across various subjects and need quick, reliable help — but many existing tools are slow, inaccurate, ad-filled, or provide only final answers without explanations that promote real understanding. This leads to frustration, poor learning outcomes, time wasted searching for solutions, and difficulty tracking progress or identifying weak areas, especially during late-night study sessions or tight deadlines.",
    solution:
      "Homework Rabbit is a comprehensive AI platform that instantly delivers detailed, step-by-step homework solutions with educational depth. Users simply take a photo of their question, upload images, type/paste text, or use voice input — the AI provides accurate, expert-verified explanations in seconds. Features smart AI analysis that understands context, recognizes patterns, and explains concepts clearly. Includes personalized learning paths, progress tracking dashboard, performance analytics, and tailored study recommendations. Covers 15+ subjects including Mathematics, Physics, Chemistry, Computer Science, and more. Public Playground for no-signup instant trials with 24/7 availability and multi-language support.",
    technologies: [
      "Next.js",
      "NextAuth",
      "Convex",
      "OpenAI API",
      "Image OCR",
      "NLP Processing",
      "Tailwind CSS",
      "Real-time Analytics",
    ],
    results: [
      "500K+ problems solved",
      "500K+ students helped",
      "4.9/5 user rating",
      "99% accuracy rate",
      "98% success rate",
      "99.9% uptime",
      "~2.3s response time",
      "Testimonials from Princeton, Stanford, MIT students",
    ],
    link: "https://www.homeworkrabbit.com",
    image: "/images/Projects/Home-Work-Rabbit/cover-1.png",
    images: [
      "/images/Projects/Home-Work-Rabbit/cover-1.png",
      "/images/Projects/Home-Work-Rabbit/cover-2.png",
      "/images/Projects/Home-Work-Rabbit/cover-3.png",
    ],
  },
  {
    title: "Rafiq: Quran Athan Prayer – Your Trusted Islamic Companion App",
    category: "Lifestyle / Islamic Tools & Reference",
    challenge:
      "In today's fast-paced, distraction-filled world, many Muslims struggle to maintain consistent daily spiritual routines — such as performing Salah on time, finding the correct Qibla direction while traveling, accessing the Quran with understanding (translations/tafsir/audio), remembering duas & azkar, and staying connected to Islamic events and practices. Existing apps often include ads, distractions, poor location accuracy, or fragmented features.",
    solution:
      "Rafiq serves as a complete, distraction-free, ad-free Islamic companion app that integrates essential daily tools into one clean platform. Features include accurate location-based prayer times with customizable Athan notifications, built-in Qibla compass, full Quran with multiple translations, tafsir explanations, and high-quality audio recitations by famous Qaris. Also includes curated duas, daily azkar (morning/evening), tasbih/dhikr counter, mosque finder, and Islamic calendar with key dates and events. Fully free, self-funded via the Ummaah Initiative with no ads.",
    technologies: [
      "React Native",
      "Kotlin",
      "GPS & Geolocation APIs",
      "Audio Playback Engine",
      "Compass/Magnetometer Sensors",
      "Firebase",
      "Material Design UI",
      "Offline-First Architecture",
    ],
    results: [
      "100+ downloads on Google Play",
      "Ad-free & distraction-free experience",
      "Accurate prayer times & Qibla",
      "Full Quran with translations & audio",
      "Mosque finder integration",
      "Part of Ummaah Initiative",
    ],
    link: "https://play.google.com/store/apps/details?id=com.rafiqapp",
    image: "/images/Projects/Rafiq App/cover-1.png",
    images: [
      "/images/Projects/Rafiq App/cover-1.png",
      "/images/Projects/Rafiq App/cover-2.png",
      "/images/Projects/Rafiq App/cover-3.png",
    ],
  },
  {
    title:
      "CoverClap: Montreal's Premier Beauty Professionals Directory & Trends Hub",
    category: "Lifestyle / Beauty & Wellness Directory",
    challenge:
      "In Montreal's vibrant but fragmented beauty industry, clients struggle to find trusted, top-rated professionals for specialized services like braids, makeup, men's haircuts, coloring, highlights, black hair care, Korean hair styling, or wigs. Issues include difficulty discovering nearby artists, understanding pricing/quality, accessing reliable recommendations, and staying updated on trends. Beauty professionals face challenges in visibility, equal opportunity marketing, and growing their client base without heavy advertising costs.",
    solution:
      "CoverClap is an online business directory and community platform connecting users with Montreal's top-rated beauty artists. Features directory of Top Beauty Artists with detailed profiles (location, distance, average pricing ~$60, services list), categorized service discovery (Braids, Makeup, Men's Haircut/Barbers, Black Hair Salons, Korean Hair Salons, Wigs) with 'near me' filters, booking integration, and inspiration gallery. Includes comprehensive blog covering beauty trends, business insights, and wellness intelligence. CoverClap For Business section helps professionals join, get marketing features, and grow visibility with free edition available.",
    technologies: [
      "Next.js",
      "React",
      "MongoDB",
      "Geolocation APIs",
      "CMS Integration",
      "Tailwind CSS",
      "SEO Optimization",
      "Business Analytics",
    ],
    results: [
      "Go-to guide for Montreal beauty scene",
      "Top-rated artist profiles & discovery",
      "Free business edition for pros",
      "Growing content library & blog",
      "Average $60 pricing transparency",
      "Equal opportunity for beauty pros",
    ],
    link: "https://coverclap.com",
    image: "/images/Projects/CoverLap/cover-1.png",
    images: [
      "/images/Projects/CoverLap/cover-1.png",
      "/images/Projects/CoverLap/cover-2.png",
      "/images/Projects/CoverLap/cover-3.png",
    ],
  },
  {
    title:
      "FreeToolZone: All-in-One Free Online Creative Toolkit for Designers & Developers",
    category: "Productivity / Developer Tools / Design Utilities",
    challenge:
      "Creators, graphic designers, web developers, and content creators often need quick access to specialized tools for tasks like image editing, code formatting, text manipulation, color picking, QR code creation, and favicon generation. Many existing solutions require sign-ups, collect user data to servers (privacy risks), include ads/watermarks, have slow performance, file size limits, or force paid upgrades — leading to frustration, security concerns, and wasted time switching between sites.",
    solution:
      "FreeToolZone is a comprehensive, 100% free online platform offering 50+ professional-grade tools that run entirely in the browser (no server uploads). Features Image Tools (12+): Image Compressor (up to 80% reduction), Cropper, Resizer, Converter (PNG/JPG/WebP/GIF), Color Picker, Favicon Generator, Background Patterns. Coding Tools (10+): JSON Formatter & Validator, UUID Generator (v1/v4, bulk), Base64 Encoder/Decoder, Color Converter (HEX/RGB/HSL/CMYK). Text Tools (6+): Letter/Word Counter, Lorem Ipsum Generator, Bionic Reading Converter. QR Code Generator with customization. All processing local/client-side for speed/security, mobile-friendly, dark mode, ad-free, 24/7 availability.",
    technologies: [
      "Next.js",
      "React",
      "Canvas API",
      "Client-side Processing",
      "Tailwind CSS",
      "QRCode.js",
      "Crypto API",
      "Dark Mode UI",
    ],
    results: [
      "50+ tools available & growing",
      "Loved by thousands of creators",
      "100% privacy-first (no data collected)",
      "No sign-ups or ads",
      "Professional-grade results",
      "Mobile-friendly & fast performance",
    ],
    link: "https://freetoolzone.com",
    image: "/images/Projects/Free Tool Zone/cover-1.png",
    images: [
      "/images/Projects/Free Tool Zone/cover-1.png",
      "/images/Projects/Free Tool Zone/cover-2.png",
      "/images/Projects/Free Tool Zone/cover-3.png",
    ],
  },
  {
    title:
      "TraveloAcco: Modern Travel Agency Management Dashboard & ERP Admin Panel",
    category: "Business / Travel Tech ERP Dashboard",
    challenge:
      "Travel agency owners and admins face fragmented operations: tracking bookings across airlines/vendors, monitoring revenue/expenses in real-time, managing customer/passport/expiration details, handling on-hold/expired statuses, scheduling tasks/bookings, and analyzing earnings trends. Manual processes lead to errors, delayed insights, missed expirations (e.g., passports), poor visibility into performance metrics, and difficulty scaling operations without a unified view.",
    solution:
      "TraveloAcco provides a clean, intuitive, real-time admin dashboard for travel agencies. Features Overview Cards with key metrics (Sales, Revenue, New Clients, Active Users) with progress indicators. Interactive Scheduler/Calendar for booking/task planning. Bookings Table with destination, airline, expiration dates, status (ON HOLD/Expired), passport tracking. Expenses Breakdown with pie/ring charts (Office, Bank, Business Travel). Earnings Analytics with Weekly/Monthly/Yearly toggles and trend graphs. Full sidebar navigation (Dashboard, Customers, Bookings, Transactions, Airlines, Banks, Vendors, Tasks, Expense Accounts, Packages, Settings).",
    technologies: [
      "React.js",
      "Vite",
      "Tailwind CSS",
      "Recharts",
      "Node.js",
      "MongoDB",
      "Vercel",
      "REST APIs",
    ],
    results: [
      "Real-time KPIs with +8% daily growth",
      "75% sales performance tracking",
      "Passport & expiration alerts",
      "Earnings trend analysis",
      "Full ERP coverage (Airlines/Banks/Vendors)",
      "Scalable agency management tool",
    ],
    link: "https://traveloacco-frontend.vercel.app",
    image: "/images/Projects/Travelacco/cover-1.png",
    images: [
      "/images/Projects/Travelacco/cover-1.png",
      "/images/Projects/Travelacco/cover-2.png",
      "/images/Projects/Travelacco/cover-3.png",
    ],
  },
  {
    title: "KYCPAL - KYC Verification Platform",
    category: "Fintech Platform",
    challenge:
      "Financial institutions needed a streamlined, secure KYC verification process to onboard customers while maintaining regulatory compliance.",
    solution:
      "Created an AI-powered KYC platform with document verification, biometric authentication, and automated compliance checks.",
    technologies: [
      "React",
      "Node.js",
      "MongoDB",
      "AWS S3",
      "Tesseract OCR",
      "Face Recognition API",
    ],
    results: [
      "90% faster verification",
      "99.5% accuracy rate",
      "GDPR compliant",
      "Multi-document support",
    ],
    link: "https://www.loom.com/share/ce31facaca3b4744ae2bcfce861ae3b5",
    image: "/images/Projects/KYCPAL/cover-1.png",
    images: [
      "/images/Projects/KYCPAL/cover-1.png",
      "/images/Projects/KYCPAL/cover-2.png",
      "/images/Projects/KYCPAL/cover-3.png",
    ],
  },
  {
    title: "Type Out: Fast & Fun Online Typing Speed Test Game",
    category: "Productivity / Skill-Building Game",
    challenge:
      "Many people (students, professionals, programmers, writers) want to measure and improve their typing speed and accuracy for productivity, job requirements (e.g., data entry, coding interviews), or personal goals — but free tools are often cluttered with ads, require sign-ups, have poor mobile support, limited test modes, inaccurate timing, or lack engaging feedback. Users need a simple, instant, no-friction way to test WPM (Words Per Minute), CPM (Characters Per Minute), accuracy, and track progress without distractions or data collection.",
    solution:
      "Type Out is a clean, browser-based typing game that lets users instantly start typing to measure speed and accuracy. Features a distraction-free interface with real-time stats and immediate feedback. One-click start with displayed sample (random words, sentences, or quotes), timer-based tests (30s, 60s, or until completion), real-time tracking displaying WPM, CPM, accuracy percentage, correct/incorrect characters, and errors as you type. Visual feedback highlights correct/wrong letters (green/red), shows progress bar or timer countdown. Restart button for quick retries, mobile-responsive design for practice anywhere. No sign-up, no ads, fully client-side — privacy-focused and instant load. Gamifies typing practice to make improvement engaging, helping users build muscle memory and speed efficiently.",
    technologies: [
      "React.js",
      "JavaScript",
      "CSS3",
      "Tailwind CSS",
      "LocalStorage",
      "Vercel",
      "Real-time Event Handling",
      "Responsive Design",
    ],
    results: [
      "Instant usability — loads in seconds",
      "Real-time WPM/CPM/accuracy tracking",
      "Visual feedback for engagement",
      "Mobile-friendly & offline-capable",
      "100% privacy-respecting (no data sent)",
      "Strong portfolio showcase piece",
      "Gamified skill-building experience",
      "Zero barriers — no sign-ups or ads",
    ],
    link: "https://typing-speed-tester-kappa.vercel.app/",
    image: "/images/Projects/Type Out/cover-1.png",
    images: [
      "/images/Projects/Type Out/cover-1.png",
      "/images/Projects/Type Out/cover-2.png",
      "/images/Projects/Type Out/cover-3.png",
    ],
  },
  {
    title:
      "Kalbosoft: Custom Software Development Agency – Mobile, Web, AI & SaaS Solutions",
    category: "Business / Software Development Agency",
    challenge:
      "Businesses, especially startups and entrepreneurs, often struggle with outdated or inefficient systems that hinder growth. They face challenges in turning innovative ideas into functional digital products, dealing with complex development processes, scalability issues, integration of emerging tech like AI, building user-friendly mobile/web apps, managing projects via intuitive dashboards, and achieving smooth, frustration-free operations without high costs or delays. Many lack access to reliable partners who deliver tailored, high-quality solutions while prioritizing simplicity and client satisfaction.",
    solution:
      "Kalbosoft delivers intelligent, custom tech solutions to help businesses upgrade and grow efficiently. As a full-service software development company (operating since 2010), they solve real-world challenges by building tailored digital products with a focus on simplicity, reliability, and excellence. Services include Mobile App Development (seamless, user-friendly applications), Web App Development (robust, scalable, interactive platforms), AI-Based Solutions (predictive analytics, intelligent automation), and SaaS Products (intuitive dashboards for full project control). Portfolio showcases real projects like KazeRide, Paywise Ai, Order.Uk, Travel Acco, and additional upcoming apps. Client-centric approach: shaping ideas into vital solutions with 100% satisfaction focus.",
    technologies: [
      "Next.js",
      "React",
      "Node.js",
      "Tailwind CSS",
      "Framer Motion",
      "AI/ML Integration",
      "Cloud Hosting",
      "Responsive Design",
    ],
    results: [
      "15+ years delivering digital solutions",
      "100% client satisfaction focus",
      "Multiple live projects delivered",
      "KazeRide, Paywise Ai, Order.Uk portfolio",
      "Trusted partner for visionary startups",
      "Positive client testimonials",
      "Ongoing project pipeline",
      "Excellence in custom software development",
    ],
    link: "https://kalbosoft.com",
    image: "/images/Projects/Kalbosoft/cover-1.png",
    images: [
      "/images/Projects/Kalbosoft/cover-1.png",
      "/images/Projects/Kalbosoft/cover-2.png",
      "/images/Projects/Kalbosoft/cover-3.png",
    ],
  },
  {
    title: "Batting King - Live Betting Platform",
    category: "Gaming Dashboard",
    challenge:
      "Sports betting enthusiasts needed a real-time platform with live odds, instant bet placement, and comprehensive betting analytics.",
    solution:
      "Developed a full-featured betting platform with real-time score updates, dynamic odds calculation, and secure transaction processing.",
    technologies: [
      "React",
      "Node.js",
      "Socket.io",
      "MongoDB",
      "Redis",
      "Chart.js",
    ],
    results: [
      "Real-time odds updates",
      "Secure transactions",
      "Live score tracking",
      "Comprehensive analytics",
    ],
    link: null,
    image: "/images/Projects/Batting-King/cover.svg",
    images: [
      "/images/Projects/Batting-King/cover.svg",
      "/images/Projects/Batting-King/cover-2.svg",
      "/images/Projects/Batting-King/cover-3.svg",
      "/images/Projects/Batting-King/cover-4.svg",
    ],
  },
  {
    title: "Ummaah Dashboard - Mosque Management",
    category: "Mosque Management",
    challenge:
      "Mosque administrators needed a comprehensive system to manage prayers, donations, members, and community events efficiently.",
    solution:
      "Built a complete mosque management dashboard with prayer scheduling, donation tracking, member management, and event organization features.",
    technologies: [
      "React",
      "Node.js",
      "MongoDB",
      "Express",
      "Chart.js",
      "Nodemailer",
    ],
    results: [
      "Automated prayer times",
      "Donation tracking",
      "Member database",
      "Event management",
    ],
    link: null,
    image: "/images/Projects/Rafiq-Dashboard/cover-5.svg",
    images: [
      "/images/Projects/Rafiq-Dashboard/cover-2.svg",
      "/images/Projects/Rafiq-Dashboard/cover-3.svg",
      "/images/Projects/Rafiq-Dashboard/cover-4.svg",
      "/images/Projects/Rafiq-Dashboard/cover-5.svg",
    ],
  },
  {
    title: "Watcher Admin: Modern Admin Dashboard & Monitoring Panel",
    category: "Business / Admin Tools",
    challenge:
      "Admins, team leads, or business owners need centralized visibility into operations — such as user activity, sessions, performance metrics, alerts, logs, revenue/usage trends, or real-time monitoring — but many tools are fragmented (separate analytics, logs, CRM), slow to load, hard to customize, privacy-risky (data-heavy cloud services), or expensive for small teams/startups. Without a unified, fast, intuitive dashboard, decision-making suffers from delayed insights, missed issues (e.g., downtime, anomalies), poor scalability, and manual tracking across tools.",
    solution:
      "Watcher Admin is a sleek, responsive admin panel that provides a unified interface for oversight and management. Features clean sidebar navigation (Dashboard, Users, Sessions, Analytics, Settings, Logs/Alerts), overview cards with KPIs (active users/sessions, revenue/usage stats, growth percentages, error rates), real-time charts/graphs (line for trends, pie for breakdowns, bar for categories), and tables for detailed views (recent activities, user lists, sessions with timestamps/status). Includes monitoring features with alerts/notifications, session watching, and performance metrics. Authentication-protected with focus on simplicity, speed, and actionability — enabling quick decisions, issue spotting, and operational efficiency.",
    technologies: [
      "React.js",
      "Next.js",
      "Tailwind CSS",
      "Shadcn/UI",
      "Recharts",
      "Socket.io",
      "MongoDB",
      "Vercel",
    ],
    results: [
      "Fast & accessible on global CDN",
      "Real-time monitoring capabilities",
      "Professional admin UX design",
      "Unified operations visibility",
      "Automated alerts & notifications",
      "Role-based access control",
      "Scalable for growing teams",
      "Strong portfolio showcase piece",
    ],
    link: null,
    image: "/images/Projects/Watcher-Admin/cover-1.svg",
    images: [
      "/images/Projects/Watcher-Admin/cover-1.svg",
      "/images/Projects/Watcher-Admin/cover-2.svg",
      "/images/Projects/Watcher-Admin/cover-3.svg",
    ],
  },
  {
    title: "Estatein - Real Estate Platform",
    category: "Real Estate",
    challenge:
      "Real estate agents and buyers needed a modern platform for property listings, virtual tours, and mortgage calculations.",
    solution:
      "Developed a comprehensive real estate platform with advanced search filters, property listings, agent profiles, and mortgage calculators.",
    technologies: [
      "React",
      "Node.js",
      "MongoDB",
      "Google Maps API",
      "Tailwind CSS",
    ],
    results: [
      "Advanced property search",
      "Virtual tour support",
      "Mortgage calculator",
      "Agent dashboard",
    ],
    link: null,
    image: "/images/Projects/Estatein/cover.svg",
    images: [
      "/images/Projects/Estatein/cover.svg",
      "/images/Projects/Estatein/cover-2.svg",
    ],
  },
  {
    title: "URL Shortener - Link Management",
    category: "Web Application",
    challenge:
      "Users needed a reliable URL shortening service with analytics tracking, custom aliases, and QR code generation.",
    solution:
      "Built a full-featured URL shortening platform with click analytics, geographic tracking, custom short links, and QR code generation.",
    technologies: ["React", "Node.js", "MongoDB", "QRCode.js", "Chart.js"],
    results: [
      "Custom short URLs",
      "Click analytics",
      "QR code generation",
      "Geographic tracking",
    ],
    link: null,
    image: "/images/Projects/URL-Shortner-App/cover.svg",
    images: [
      "/images/Projects/URL-Shortner-App/cover.svg",
      "/images/Projects/URL-Shortner-App/conver-2.svg",
    ],
  },
  {
    title: "Order.UK - Food Delivery Platform",
    category: "Food Delivery",
    challenge:
      "Restaurants and customers needed a seamless food ordering platform with real-time order tracking and multiple payment options.",
    solution:
      "Created a food delivery platform with restaurant listings, menu management, order tracking, and integrated payment processing using Next.js.",
    technologies: [
      "Next.js",
      "React",
      "Tailwind CSS",
      "Node.js",
      "MongoDB",
      "Stripe",
    ],
    results: [
      "Real-time order tracking",
      "Multi-restaurant support",
      "Secure payments",
      "Mobile responsive",
    ],
    link: null,
    image: "/images/Projects/Order.Uk/cover.svg",
    images: ["/images/Projects/Order.Uk/cover.svg"],
  },
];
